import { getHost } from "@src/env";

import { parseJSON } from "@src/utils/json";
import { safeFetch } from "@src/utils/safeFetch";

export type Provider = "radioindoor" | "elevenlabs" | "azure";

type GetAudioUrl = (voice: string, text: string) => Promise<string>;

export const ttsProviders: Record<
  number,
  {
    name: Provider;
    /** `undefined` = no volume control */
    initialVolume?: number;
    initialSpeed: number;
    getAudioUrl: GetAudioUrl;
  }
> = {
  1: {
    name: "radioindoor",
    initialSpeed: 0.9,
    getAudioUrl: async (voice, text) => {
      const secretKey = "fabriccaradio";
      const host = getHost();
      const response = await safeFetch(
        "TTS getAudioUrl",
        `${host}/radioindoor/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ text, voice, secretKey }),
        },
      );
      const json = await parseJSON("TTS getAudioUrl", response);
      if (!("url" in json)) {
        throw new Error("Falha ao ler a resposta de TTS");
      }
      const audioResponse = await fetch(json["url"]);
      if (!audioResponse.body) {
        throw new Error("Falha ao ler o áudio TTS");
      }
      // response.blob() define o type do Blob a partir do Content-Type da
      // resposta — sem type, o <audio> falha com NotSupportedError.
      const blob = await audioResponse.blob();
      return URL.createObjectURL(blob);
    },
  },
  2: {
    name: "elevenlabs",
    initialSpeed: 1.0,
    getAudioUrl: async (voice, text) => {
      const token = "b3vutd5cvgg5mc1tdnnse8c2kytwapsl";
      const host = getHost();
      const response = await safeFetch(
        "TTS getAudioUrl",
        `${host}/tts?token=${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ text, voice }),
        },
      );
      if (!response.body) {
        throw new Error("Falha ao ler a resposta de TTS");
      }
      const blob = await response.blob();
      const audioUrl = URL.createObjectURL(blob);
      return audioUrl;
    },
  },
  3: {
    name: "azure",
    initialSpeed: 0.9,
    getAudioUrl: async (voice, text) => {
      const token = "b3vutd5cvgg5mc1tdnnse8c2kytwapsl";
      const host = getHost();
      const response = await safeFetch(
        "TTS getAudioUrl",
        `${host}/tts/azure?token=${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ text, voice }),
        },
      );
      if (!response.body) {
        throw new Error("Falha ao ler a resposta de TTS");
      }
      const blob = await response.blob();
      const audioUrl = URL.createObjectURL(blob);
      return audioUrl;
    },
  },
};
